<template>
  <div class="fullSized">
    <div class="section portrait">
      <div class="col1 clock">
        <div class="autoMargin">{{ today }}<br />{{ time_now }}</div>
      </div>
      <div class="col2 title">
        <div class="autoMargin">Now</div>
      </div>
      <div class="col34 title">
        <div class="autoMargin">Next</div>
      </div>
    </div>
    <court court="1"></court>
    <court court="2"></court>
    <court court="3"></court>
    <court court="4"></court>
    <court court="5"></court>
  </div>
</template>
<script>
  import moment from 'moment'; 
  import court from './Court.vue';

  export default {
    data() {
      return {
        today: this.getToday(),
        time_now: this.getTime()
      }
    },
    components: {
      court
    },
    methods: {
      getToday() {
        var date = new Date();
        date = moment(date)
        return date.format('MMM DD')
      },
      getTime() {
        var date = new Date();
        date = moment(date)
        return date.format('hh:mmA')
      }
    }
  };
</script>
<style>
  body,
  html {
    height: 100%;
    background: transparent;
  }


  .fullSized {
    /* background-image: url(/images/TheLights/theLights-MediaScreenBG.jpg); */
    /* Center and scale the image nicely */
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;

    /* Full height */
    position: absolute;
    height: 1920px;
    width: 100%;
  }
</style>
<style lang="scss" scoped>
  .section {
    padding: 0;
    display: flex;
    height: 180px;
  }

  .clock {
    color: #fff;
  }


  .col1,
  .col2,
  .col3,
  .col4,
  .col34 {
    vertical-align: middle;
    /* display: grid; */
    display: flex;
    align-content: center;
    text-align: center;
    margin: 0 2px;
    color: #fff;
    padding: 0 .4rem;
  }



  .landscape {
    .col1 {
      width: 10%;
      color: #eee;
      font-size: 1.4rem;
    }

    .col2 {
      width: 30%;
    }

    .col3 {
      width: 10%;
    }

    .col4 {
      width: 49%;
    }

    .col34 {
      width: 59%;
    }
  }


  .portrait {
    .col1 {
      width: 9%;
    }

    .col2 {
      width: 45%;
    }

    .col3 {
      width: 10%;
    }

    .col4 {
      width: 49%;
    }

    .col34 {
      width: 45%;
    }
  }

  .title {
    font-size: 5rem;
    color: #fff;
    text-align: center;
  }


  .autoMargin {
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/thelights/Games.vue